import { TExtendedSurfaceItem } from 'entries/common/widgets/context';
import { ParametersEnum } from '../types';

export const hasWallAreaInRoom = (filteredSurfaces: TExtendedSurfaceItem[]) =>
  filteredSurfaces.some(
    surface => surface.name === 'wall' && !surface?.inputParameters.includes(ParametersEnum.area)
  );
